export default __webpack_public_path__ + "static/media/img-booking.3ffc8a07.png";